import axios from "axios";

export function resolveApiBase(raw = "", sameOrigin = false) {
  const value = raw.trim().replace(/\/+$/, "");
  if (!value) return sameOrigin ? "/api" : null;
  try {
    const url = new URL(value);
    if (!["http:", "https:"].includes(url.protocol) || url.username || url.password || url.search || url.hash) return null;
    if (typeof window !== "undefined" && window.location.protocol === "https:" && url.protocol !== "https:") return null;
    if (url.pathname !== "/" && url.pathname !== "/api") return null;
    return `${url.origin}/api`;
  } catch { return null; }
}

const baseURL = resolveApiBase(process.env.REACT_APP_BACKEND_URL, process.env.REACT_APP_API_SAME_ORIGIN === "true");
const api = axios.create({ baseURL: baseURL || undefined, withCredentials: false, timeout: 20000 });
const TOKEN_KEY = "auth_token";
let memoryToken;
export function setToken(token) {
  memoryToken = token || null;
  try { if (token) localStorage.setItem(TOKEN_KEY, token); else localStorage.removeItem(TOKEN_KEY); } catch { /* Restricted storage: session remains usable in memory. */ }
}
export function clearToken() { setToken(null); }
export function getToken() {
  if (memoryToken !== undefined) return memoryToken;
  try { return localStorage.getItem(TOKEN_KEY); } catch { return null; }
}
api.interceptors.request.use(config => {
  if (!baseURL) return Promise.reject(new Error("API_NOT_CONFIGURED"));
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
export function formatLoginError(error) {
  if (error?.message === "API_NOT_CONFIGURED") return "The monitoring API address is not configured correctly. Please contact support.";
  if (error?.code === "ECONNABORTED") return "The monitoring API took too long to respond. Please retry.";
  if (typeof navigator !== "undefined" && navigator.onLine === false) return "You appear to be offline. Reconnect and retry.";
  if (!error?.response) return "Cannot reach the monitoring API. Check your connection and retry. If this continues, contact support.";
  if (error.response.status >= 500) return "The monitoring service is temporarily unavailable. Please retry shortly.";
  return formatApiErrorDetail(error.response.data?.detail);
}
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map(e => e?.msg || "Invalid input").join(" ");
  return detail?.msg || "The request could not be completed.";
}
export default api;
